<script setup>
defineProps({ name: { type: String, default: 'devices' } });
const paths = {
  devices: 'M4 4h6v6H4z M14 4h6v6h-6z M4 14h6v6H4z M14 14h6v6h-6z',
  users: 'M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2 M16 3a4 4 0 0 1 0 8 M22 21v-2a4 4 0 0 0-3-3.87 M13 7a4 4 0 1 1-8 0 4 4 0 0 1 8 0',
  arrow: 'm9 5 7 7-7 7', back: 'm12 5-7 7 7 7 M5 12h14',
  refresh: 'M20 7v5h-5 M4 17v-5h5 M6.1 6.1a8 8 0 0 1 13.2 3 M4.7 14.9a8 8 0 0 0 13.2 3',
  menu: 'M4 6h16 M4 12h16 M4 18h16', close: 'm6 6 12 12 M6 18 18 6',
  leaf: 'M20 4C9 2 3 6 4 13c1 7 13 8 16-9Z M4 21 15 10',
  logout: 'M9 4H4v16h5 M10 12h11 m-4-4 4 4-4 4',
  info: 'M12 11v6 M12 7v.01 M22 12a10 10 0 1 1-20 0 10 10 0 0 1 20 0',
  variables: 'M4 6h16 M4 12h16 M4 18h16 M8 3v6 M16 9v6 M8 15v6',
  report: 'M5 20V10 M12 20V4 M19 20v-7',
  activity: 'M3 12h4l2.5-7 5 14 2.5-7h4',
};
</script>
<template><svg class="app-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path :d="paths[name] || paths.devices" /></svg></template>
